import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { useRef, useState } from 'react';
import {
  small_edit,
  small_trash,
} from 'Components/CommonComponents/Icons';
import { Popconfirm, Tooltip } from 'antd';
import { useGetAssignedInterviews } from 'ServiceHooks/jobHooks';
import toast from 'react-hot-toast';

const ItemType = 'INTERVIEW_LEVEL';

const InterviewLevelCard = ({
  item,
  index,
  moveCard,
  editLevel,
  deleteInterviewLevel,
  prescreeningList,
  questionaireList,
  jobId,
}) => {
  const ref = useRef(null);
  const {
    data: assignedInterviewDetails,
    status: candidateAppliedJobsStatus,
  } = useGetAssignedInterviews({
    params: {
      jobId: jobId,
      interviewId: item.id,
    },
    enabled: !!jobId && !!item.id,
  });
  // Drag Hook
  const [{ isDragging }, drag] = useDrag({
    type: ItemType,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: ItemType,
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveCard(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  drag(drop(ref));
  const handleDelete = () => {
    if (assignedInterviewDetails?.status === 200) {
      deleteInterviewLevel(index);
    } else {
      toast.error(
        'Interviews are already scheduled.Cant delete the interview levels',
      );
    }
  };
  return (
    <div
      ref={ref}
      className="rounded p-3 bg-white border-[0.5px] border-[#D7D7D7] mt-4"
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: 'grab',
      }}
    >
      <ul>
        <li className="flex items-center justify-between">
          <span>Level {index + 1}</span>{' '}
          <div className="flex items-center gap-2">
            <Tooltip title="Edit" placement="bottom">
              <img
                onClick={() => editLevel(item.interview_type, index)}
                src={small_edit}
                alt="edit"
                className="cursor-pointer"
                width={15}
              />
            </Tooltip>
            <Popconfirm
              placement="bottom"
              title={`Are You Sure You want to Delete`}
              description=""
              onConfirm={handleDelete}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip title="Delete">
                <img
                  // onClick={() => deleteInterviewLevel(index)}
                  src={small_trash}
                  alt="delete"
                  className="cursor-pointer"
                  width={15}
                />
              </Tooltip>
            </Popconfirm>
            {/* <Tooltip title="Delecxvte" placement="bottom">
              <img
                onClick={handleDelete}
                // onClick={() => deleteInterviewLevel(index)}
                src={small_trash}
                alt="delete"
                className="cursor-pointer"
                width={15}
              />
            </Tooltip> */}
          </div>
        </li>
        <li>
          <span className="level_leftHeading">Round Name :</span>
          <span className="level_rightContent">
            {item?.round_name ? item?.round_name + ', ' : '-'}
          </span>
        </li>
        <li>
          <span className="level_leftHeading">Interview Type :</span>
          <span className="level_rightContent">
            {' '}
            {prescreeningList &&
              prescreeningList.interview_types?.map((iTypeList) => {
                if (iTypeList.id == item.interview_type) {
                  //setRadioButtonShow(iTypeList.interview_type_selection_required)
                  return iTypeList.name;
                }
              })}
          </span>
        </li>
        <li>
          <span className="level_leftHeading">Interviewer :</span>
          <span className="level_rightContent">
            {' '}
            {item.interviewer?.map((data) => {
              return data.first_name + ', ';
            })}
          </span>
        </li>
        <li>
          <span className="level_leftHeading">Email :</span>
          <span className="level_rightContent">
            {' '}
            {item.interviewer?.map((data) => {
              return data.email + ', ';
            })}
          </span>
        </li>
        <li>
          <span className="level_leftHeading">Phone No :</span>
          <span className="level_rightContent">
            {' '}
            {item.interviewer?.map((data) => {
              return data.mobile_number + ', ';
            })}
          </span>
        </li>
        <li>
          <span className="level_leftHeading">Designation :</span>
          <span className="level_rightContent">
            {' '}
            {item.interviewer?.map((data) => {
              return data.designation + ', ';
            })}
          </span>
        </li>
      </ul>
      <ul style={{ borderTop: '1px solid lightgray', paddingTop: '2px' }}>
        <li className="level_heading">Other Jobs assigned</li>
        <li>
          {item.interviewer?.map((data) => {
            return data.assigned_jobs?.length > 0 ? (
              data.assigned_jobs.map((jobName) => {
                return jobName + ', ';
              })
            ) : (
              <h6 style={{ color: 'red' }}>No Job Assigned</h6>
            );
          })}{' '}
        </li>
      </ul>
      <ul style={{ borderTop: '1px solid lightgray', paddingTop: '2px' }}>
        <li className="level_heading">Questionnaire</li>
        <li>
          {' '}
          {questionaireList &&
            questionaireList?.map((iTypeList) => {
              if (iTypeList.id == item.evaluation_questionaire) {
                return iTypeList.title;
              }
            })}
          {item.evaluation_questionaire === undefined ||
            (item.evaluation_questionaire === null && (
              <h6 style={{ color: 'red' }}>No Questionnaire Assigned</h6>
            ))}
        </li>
      </ul>
    </div>
  );
};

const InterviewLevels = ({
  selectedInterviewLevel,
  setSelectedInterviewLevel,
  editLevel,
  deleteInterviewLevel,
  prescreeningList,
  questionaireList,
  isEdit,
  jobId,
}) => {
  const moveCard = (fromIndex, toIndex) => {
    const updatedLevels = [...selectedInterviewLevel];
    const [movedItem] = updatedLevels.splice(fromIndex, 1);
    updatedLevels.splice(toIndex, 0, movedItem);
    if (!isEdit) {
      setSelectedInterviewLevel(updatedLevels);
    }
  };

  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        {selectedInterviewLevel?.map((item, index) => (
          <InterviewLevelCard
            key={index}
            index={index}
            item={item}
            moveCard={moveCard}
            editLevel={editLevel}
            deleteInterviewLevel={deleteInterviewLevel}
            prescreeningList={prescreeningList}
            questionaireList={questionaireList}
            jobId={jobId}
          />
        ))}
      </div>
    </DndProvider>
  );
};

export default InterviewLevels;
